import type { GameState } from './types';

export const LEGACY_ROOM_ID = 'single-room-v1-apac';
export const MAX_ROOMS = 32;
export interface RoomSummary {
  id: string;
  name: string;
  mapId: string;
  playerCount: number;
  connectedCount: number;
  readyCount: number;
  phase: GameState['phase'];
  updatedAt: number;
  available?: boolean;
}
export function validRoomId(id: unknown): id is string {
  return typeof id === 'string' && (id === LEGACY_ROOM_ID || /^room-[a-f0-9]{12}$/.test(id));
}
export function battleRoomName(id: string): string {
  return id === LEGACY_ROOM_ID ? LEGACY_ROOM_ID : `battle-room-v2:${id}`;
}
